export function loadScript(u: string, c: any): void {
    const d = document, t = 'script',
            o = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
    o.src = u;
    o.async = true;
    o.defer = true;
    if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
    s.parentNode?.insertBefore(o, s);
}